import styled from 'styled-components'

const Container = styled.div`
  min-width: 100%;
  position: sticky;
  top: 143px;
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 0;
  }

  .MuiAccordionSummary-root {
    padding: 3px 20px;
    min-height: 41px;
    border-radius: 10px;
    margin-bottom: 14px;
  }
  .detail-section {
    display: flex;
    flex-direction: column;
    padding: 0;

    .pallets-link {
      border-radius: 17px;
      background-color: #fff;
      color: #0a5587 !important;
      height: 66px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 10px;
      padding: 0 20px;
      box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
      p {
        margin: 0;
        font-family: "latobold";
        font-size: 14px;
      }
    }
    .main-nav-activeTab {
      border: 2px solid #87cdf1;
    }
    .main-navDark-activeTab {
      border: 2px solid #2d5d7c;
    }
  }
  .MuiAccordionSummary-content {
    padding: 0;
    margin: 0 !important;
    min-height: 0;
    color: #fff;
  }
  .MuiIconButton-root {
    padding: 0 12px;
  }

  .MuiSvgIcon-root {
    font-size: 34px;
    color: #fff;
  }
  .MuiAccordion-root.Mui-expanded,
  .MuiPaper-elevation1 {
    box-shadow: none;
    background: transparent;
    margin-bottom: 11px;
    margin-top: 0;
  }
  .MuiAccordion-root.Mui-disabled {
    background-color: transparent;
  }
  .buy-pallets {
    .MuiAccordionSummary-root {
      background-color: #0a5587;
    }

    h2 {
      font-size: 20px;
      font-family: "latobold";
      line-height: 30px;
    }
  }
  .sell-pallets {
    .MuiAccordionSummary-root {
      background-color: #87cdf1;
    }

    h2 {
      font-size: 20px;
      font-family: "latobold";
      line-height: 30px;
    }
  }
  @media (max-width: 1250px) {
    display: none;
  }
`;

const IconWrapper = styled.div`
  display: grid;
  grid-template-columns: 50px auto;
  grid-gap:10px;
  align-items: center;
`

export { Container, IconWrapper };